import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcLetter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 62,
	height: 64,
	viewBox: "0 0 62 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M54.5985 20.6598H7.5L20.9366 8.85467C26.7032 3.78824 35.3322 3.78202 41.1061 8.84012L54.5985 20.6598Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_4094_31256)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 10.4355,
				y: 11.3887,
				width: 41.2278,
				height: 38.6907,
				rx: 4,
				fill: "url(#paint0_linear_4094_31256)"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.5986 50.9996V20.5156L7.50013 50.9996H54.5986Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 50.9996V20.5156L54.5985 50.9996H7.5Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.3097 50.999H7.78906L23.6725 39.2591C28.0566 36.0187 34.0421 36.0187 38.4262 39.2591L54.3097 50.999Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M48.3863 38.7207H48.7662C48.7662 38.878 48.8937 39.0054 49.051 39.0054C49.2083 39.0054 49.3358 38.878 49.3358 38.7207H49.7151C49.7152 38.878 49.8427 39.0054 49.9999 39.0054C50.1572 39.0054 50.2847 38.878 50.2847 38.7207H50.6647C50.6647 38.878 50.7922 39.0054 50.9495 39.0054C51.1067 39.0054 51.2342 38.878 51.2343 38.7207H51.7089V39.101H51.7089C51.5516 39.101 51.4241 39.2285 51.4241 39.3858C51.4241 39.5431 51.5516 39.6707 51.7089 39.6707H51.7089V40.05H51.7089C51.5516 40.05 51.4241 40.1775 51.4241 40.3348C51.4241 40.4921 51.5516 40.6196 51.7089 40.6196H51.7089V41.0001H51.7089C51.5516 41.0001 51.4241 41.1276 51.4241 41.2849C51.4241 41.4422 51.5516 41.5698 51.7089 41.5698H51.7089V41.9491H51.7089C51.5516 41.9491 51.4241 42.0766 51.4241 42.2339C51.4241 42.3912 51.5516 42.5187 51.7089 42.5187H51.7089V42.8992H51.7089C51.5516 42.8992 51.4241 43.0267 51.4241 43.184C51.4241 43.3413 51.5516 43.4689 51.7089 43.4689H51.7089V43.8469H51.7089C51.5516 43.8469 51.4241 43.9744 51.4241 44.1317C51.4241 44.289 51.5516 44.4166 51.7089 44.4166H51.7089V44.7971H51.7089C51.5516 44.7971 51.4241 44.9246 51.4241 45.0819C51.4241 45.2392 51.5516 45.3667 51.7089 45.3667H51.7089V45.746H51.7089C51.5516 45.746 51.4241 45.8735 51.4241 46.0308C51.4241 46.1881 51.5516 46.3157 51.7089 46.3157H51.7089V46.695H51.7089C51.5516 46.695 51.4241 46.8225 51.4241 46.9798C51.4241 47.1371 51.5516 47.2646 51.7089 47.2646H51.7089V47.6451H51.7089C51.5516 47.6451 51.4241 47.7726 51.4241 47.9299C51.4241 48.0873 51.5516 48.2148 51.7089 48.2148H51.7089V48.6894H51.2343V48.6893C51.2343 48.532 51.1068 48.4045 50.9495 48.4045C50.7922 48.4045 50.6647 48.532 50.6647 48.6893V48.6894H50.2847V48.6893C50.2847 48.532 50.1572 48.4045 49.9999 48.4045C49.8426 48.4045 49.7151 48.532 49.7151 48.6893V48.6894H49.3358V48.6893C49.3358 48.532 49.2083 48.4045 49.051 48.4045C48.8937 48.4045 48.7662 48.532 48.7662 48.6893V48.6894H48.3863V48.6893C48.3863 48.532 48.2587 48.4045 48.1014 48.4045C47.9441 48.4045 47.8166 48.532 47.8166 48.6893V48.6894H47.4367V48.6893C47.4367 48.532 47.3092 48.4045 47.1519 48.4045C46.9946 48.4045 46.8671 48.532 46.8671 48.6893V48.6894H46.4872V48.6893C46.4872 48.532 46.3596 48.4045 46.2023 48.4045C46.045 48.4045 45.9175 48.532 45.9175 48.6893V48.6894H45.5382V48.6893C45.5382 48.532 45.4107 48.4045 45.2534 48.4045C45.0961 48.4045 44.9686 48.532 44.9686 48.6893V48.6894H44.5887V48.6893C44.5887 48.532 44.4612 48.4045 44.3039 48.4045C44.1466 48.4045 44.019 48.532 44.019 48.6893V48.6894H43.6391V48.6893C43.6391 48.532 43.5116 48.4045 43.3543 48.4045C43.197 48.4045 43.0695 48.532 43.0695 48.6893V48.6894H42.6896V48.6893C42.6896 48.532 42.5621 48.4045 42.4048 48.4045C42.2474 48.4045 42.1199 48.532 42.1199 48.6893V48.6894H41.7402V48.2148C41.8975 48.2147 42.0249 48.0872 42.0249 47.9299C42.0249 47.7727 41.8975 47.6452 41.7402 47.6451V47.2646C41.8975 47.2645 42.0249 47.137 42.0249 46.9798C42.0249 46.8225 41.8975 46.695 41.7402 46.695V46.3157C41.8975 46.3156 42.0249 46.1881 42.0249 46.0308C42.0249 45.8736 41.8975 45.7461 41.7402 45.746V45.3667C41.8975 45.3667 42.0249 45.2392 42.0249 45.0819C42.0249 44.9246 41.8975 44.7972 41.7402 44.7971V44.4166C41.8975 44.4165 42.0249 44.289 42.0249 44.1317C42.0249 43.9745 41.8975 43.847 41.7402 43.8469V43.4689C41.8975 43.4688 42.0249 43.3413 42.0249 43.184C42.0249 43.0268 41.8975 42.8993 41.7402 42.8992V42.5187C41.8975 42.5186 42.0249 42.3911 42.0249 42.2339C42.0249 42.0766 41.8975 41.9491 41.7402 41.9491V41.5698C41.8975 41.5697 42.0249 41.4422 42.0249 41.2849C42.0249 41.1277 41.8975 41.0002 41.7402 41.0001V40.6196C41.8975 40.6195 42.0249 40.492 42.0249 40.3348C42.0249 40.1775 41.8975 40.05 41.7402 40.05V39.6707C41.8975 39.6706 42.0249 39.5431 42.0249 39.3858C42.0249 39.2286 41.8975 39.1011 41.7402 39.101V38.7207H42.1199C42.12 38.878 42.2475 39.0054 42.4048 39.0054C42.562 39.0054 42.6895 38.878 42.6896 38.7207H43.0695C43.0695 38.878 43.197 39.0054 43.3543 39.0054C43.5116 39.0054 43.6391 38.878 43.6391 38.7207H44.019C44.0191 38.878 44.1466 39.0054 44.3039 39.0054C44.4611 39.0054 44.5886 38.878 44.5887 38.7207H44.9686C44.9686 38.878 45.0961 39.0054 45.2534 39.0054C45.4107 39.0054 45.5382 38.878 45.5382 38.7207H45.9181C45.9182 38.878 46.0457 39.0054 46.203 39.0054C46.3602 39.0054 46.4877 38.878 46.4878 38.7207H46.8671C46.8671 38.878 46.9946 39.0054 47.1519 39.0054C47.3092 39.0054 47.4367 38.878 47.4367 38.7207H47.8166C47.8167 38.878 47.9442 39.0054 48.1014 39.0054C48.2587 39.0054 48.3862 38.878 48.3863 38.7207Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42.5,
			y: 39.4805,
			width: 8.44966,
			height: 8.44966,
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 43.7334,
			y: 40.7148,
			width: 3.89751,
			height: 3.89748,
			fill: "#415E96"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 44.3828,
			y: 41.2461,
			width: 3.89751,
			height: 3.89748,
			fill: "#415E96"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45.0332,
			y: 41.9551,
			width: 3.89751,
			height: 3.89748,
			fill: "#415E96"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45.6816,
			y: 42.6035,
			width: 3.89751,
			height: 3.95653,
			fill: "#415E96"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.5088 41.3633V43.8435H47.7489",
			stroke: "white",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_4094_31256",
			x: .128798,
			y: 4.51751,
			width: 61.841,
			height: 59.3049,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 3.43558 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5.15337 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0235294 0 0 0 0 0.0313726 0 0 0 0 0.0470588 0 0 0 0.04 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_4094_31256"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_4094_31256",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4094_31256",
			x1: 31.0494,
			y1: 11.3887,
			x2: 31.0494,
			y2: 50.0794,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E7EFFF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white"
			})]
		})] })
	]
});
export default SvgIcLetter;
